<div style="height: 75vh;" *ngIf="sliders.length == 0">

</div>

<owl-carousel-o [options]="HomeSliderConfig" class="home-slider hidevalue" [ngClass]="class" *ngIf="sliders.length > 1">
	<ng-container *ngFor="let slider of sliders">
		<ng-template carouselSlide>
			<div class="home" [ngClass]="textClass" [ngStyle]="{'background-image': 'url('+slider.imgurl+')'}">
				<div class="container">
					<div class="row">
						<div class="col">
							<div class="slider-contain">
								<div>
									<h4 [ngStyle]="{'color': slider.f1_color}">{{slider.Pdesc}}</h4>
									<h1 [ngStyle]="{'color': slider.f2_color}">{{slider.Pname}}</h1>
									<a [routerLink]="['/shop/cakes/collection']" [queryParams]="{ category: category}"
										class="btn btn-solid" [ngClass]="buttonClass">
										{{buttonText}}
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-template>
	</ng-container>
</owl-carousel-o>

<owl-carousel-o [options]="HomeSliderConfig" class="home-slider mobilehide" [ngClass]="class"
	*ngIf="sliders.length > 1">
	<ng-container *ngFor="let slider of sliders">
		<ng-template carouselSlide>
			<div class="home" [ngClass]="textClass" [ngStyle]="{'background-image': 'url('+slider.imgurl+')'}">
				<div class="container">
					<div class="row">
						<div class="col">
							<div class="slider-contain">
								<div class="slider-content">
									<h4 [ngStyle]="{'color': slider.f1_color}" class="slider-desc">{{slider.Pdesc}}</h4>
									<h1 [ngStyle]="{'color': slider.f2_color}" class="slider-title">{{slider.Pname}}
									</h1>
									<a [routerLink]="['/shop/cakes/collection']" [queryParams]="{ category: category}"
										class="btn btn-solid" [ngClass]="buttonClass">
										{{buttonText}}
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-template>
	</ng-container>
</owl-carousel-o>


<div style="height: 70vh;" *ngIf="sliders.length == 1">
	<div class="singleHome" [ngClass]="textClass"
		[ngStyle]="{'background-image': 'url(https://biz1ps.azurewebsites.net/temp/audio/Banner-1.jpg)'}">
		<div class="container">
			<div class="row">
				<div class="col">
					<div class="slider-contain1">
						<div>
							<h4 *ngIf="sliders.length > 0">{{sliders[0]?.Pdesc}}</h4>
							<h1>{{sliders[0]?.Pname}}</h1>

							<a [routerLink]="['/shop/cakes/collection']" [queryParams]="{ category: category}"
								class="btn btn-solid" [ngClass]="buttonClass">
								Shop Now
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>